import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Layout from "../components/Layout";
import InfoFooter from "../components/InfoFooter";

const NotFound = () => (
  <Layout>
    <Helmet title="Stránka nenalezena | Optika Volyně">
      <meta name="robots" content="noindex" />
    </Helmet>
    <main className="additional-pages-main">
      <h1>Stránku se nepodařilo najít</h1>
      <p>
        Zkontrolujte prosím zadanou adresu, nebo se vraťte na úvodní stránku.
        Pokud potíže přetrvávají, kontaktujte prosím správce webu.
      </p>
      <Link className="btn" to="/">
        Zpět na úvodní stránku
      </Link>
    </main>
    <InfoFooter className="additional-pages-footer" />
  </Layout>
);

export default NotFound;
